import { Component, ElementRef, HostListener, OnInit, inject, input, output } from '@angular/core';
import { AgGridAngular } from 'ag-grid-angular';
import { Search } from 'lucide-angular';

@Component({
  selector: 'di-grid-header-top',
  templateUrl: './grid-header-top.component.html',
  standalone: false,
  host: {
    class: 'tw:block',
  },
})
export class GridHeaderTopComponent implements OnInit {
  autosizeColumns = output();
  getExcel = output();
  getCsv = output();
  changedSearchInput = output<string>();
  clearFilters = output();
  resetColumns = output();
  toggleFloatingFilter = output<boolean>();
  toggleAdvancedView = output<boolean>();

  agGrid = input<AgGridAngular>();
  isFloatingFilterPresent = input<boolean>(false);
  isAdvancedViewEnabled = input<boolean>(false);
  isAdvancedViewVisible = input<boolean>(false);
  showSearch = input<boolean>(false);

  isDropdownOpen = false;
  isFloatingFilterVisible = true;

  private readonly elementRef = inject(ElementRef);

  readonly icons = { Search };

  ngOnInit() {
    this.isFloatingFilterVisible = this.isFloatingFilterPresent();
  }

  @HostListener('document:click', ['$event.target'])
  public onClick(target) {
    const settingsBtnEl = document.querySelector('#settings-btn');
    if (!settingsBtnEl?.contains(target)) {
      this.isDropdownOpen = false;
    }
  }

  onFilterButtonClick() {
    this.isFloatingFilterVisible = !this.isFloatingFilterVisible;
    this.toggleFloatingFilter.emit(this.isFloatingFilterVisible);

    const grid = this.elementRef.nativeElement.parentElement?.querySelector('.ag-theme-visma');
    if (!grid) {
      return;
    }

    if (this.isFloatingFilterVisible) {
      grid.classList.remove('visma-floating-filter-row-hidden');
    } else {
      grid.classList.add('visma-floating-filter-row-hidden');
    }
  }
}
